'use strict';

var profilesControl = function () {
	var curProfile = void 0,
	    curDisplay = void 0,
	    status = void 0,
	    curMdo = void 0,
	    curCodhost = void 0,
	    curConcesion = void 0,
	    scrLessThan767 = void 0;
	var statusSelector = '.js-status';
	var _getCurProfile = function _getCurProfile() {
		return curProfile;
	};
	var _getCurDisplay = function _getCurDisplay() {
		return curDisplay;
	};
	var _getCurCodhost = function _getCurCodhost() {
		return curCodhost;
	};
	var _getCurConcesion = function _getCurConcesion() {
		return curConcesion;
	};
	var _getCurMdo = function _getCurMdo() {
		return curMdo;
	};
	var _setCurMdo = function _setCurMdo(value) {
		return curMdo.precio = value;
	};
	var _set = function _set(profile, display, jsonMdo, codhost, concesion) {

		curProfile = profile;
		curDisplay = display;
		curMdo = jsonMdo; // Coste mano de obra
		curCodhost = codhost;
		curConcesion = concesion;

		profilesEvents.launch();

		/*
  profiles 0 (invitado), 10 (admin), 20 (concesión ventas), 30 (concesión posventa)
  displays 10 (vista concesión), 20 (vista cliente)
  Funcionalidades = Cambio a V. Concesión, Cambio a V. Cliente, Precio Mano de Obra, Carrito, Impresión, Envío email, Listado Precios MO
  0 + [10 || 20] - ............ - 0
  		10 + 10 - Cambio a V. Cliente, Listado Precios MO, Carrito, Impresión, Envío email - 1
  10 + 20 - Cambio a V. Concesión, Listado Precios MO, Carrito, Impresión, Envío email - 5
  		20 + 10 - Sin Cambio a V. Cliente, Carrito, Impresión, Envío email - 4
  20 + 20 - Sin Cambio a V. Concesión, Carrito, Impresión, Envío email - 4
  		30 + 10 - Cambio a V. Cliente, Precio Mano de Obra, Carrito, Impresión, Envío email - 3
  30 + 20 - Cambio a V. Concesión, Carrito, Impresión, Envío email - 2
  		Estado 0:
  	- Precios: PVP y PNC
  	- Sin Carrito
  Estado 1:
  	- Precios: PVP y PNC
  	- Carrito
  Estado 2:
  	- Precios: PVP
  	- Carrito
  Estado 3:
  	- Precios: PVP y PNC
  	- Carrito
  Estado 4:
  	- Precios: PVP
  	- Carrito
  Estado 5:
  	- Precios: PVP
  	- Carrito
  		*/

		var pd = String(profile) + String(display);

		if (typeof profile === 'undefined' || profile === null || profile === 0) {
			status = 0;
		} else {
			if (pd === '1010' || pd === '2010') {
				status = 1;
			}
			if (pd === '2020' || pd === '3020') {
				status = 2;
			}
			if (pd === '3010') {
				status = 3;
			}
			if (pd === '2010' || pd === '2020') {
				status = 4;
			}
			if (pd === '1020') {
				status = 5;
			}
		}

		_controlStatus(status);
	};

	var _controlStatus = function _controlStatus(status) {

		_setViewMode(status);

		if (status === 0) {} else {
			var viewMode = void 0;
			if (status === 3 || status === 4) {
				mdoControl.init(_getCurMdo(), status);
			}

			cartList.init();
		}
	};

	var _setViewMode = function _setViewMode(status) {
		$(statusSelector).removeClass('visible');
		$(statusSelector + '.js-s' + status).addClass('visible');
	};

	return {
		set: _set,
		getCurProfile: _getCurProfile,
		getCurDisplay: _getCurDisplay,
		getCurCodhost: _getCurCodhost,
		getCurConcesion: _getCurConcesion,
		getCurMdo: _getCurMdo,
		setCurMdo: _setCurMdo
	};
}();

var profilesEvents = function () {
	var initiatedDropDown = false;
	var initiatedMobileOpener = false;

	var _initDropDown = function _initDropDown() {
		initiatedDropDown = true;
		var $container = $('.js-dropdown-container');
		$container.removeClass('visible');

		var curSection = void 0;

		$('.js-dropdown-button').off('click').on('click', function (ev) {
			ev.preventDefault();
			var target = $(this).data('target');

			// Cambia el aspecto en mobile
			if (scrLessThan767) {
				$('.js-dropdown-button').removeClass('abierto');
				$(this).addClass('abierto');
			}

			if (!scrLessThan767) {
				if (curSection !== target) {
					curSection = target;
					_showDropDownContent($container, target);
				} else {
					$container.removeClass('visible');
					curSection = undefined;
				}
			} else {
				_showDropDownContent($container, target);
			}
		});
	};

	var _showDropDownContent = function _showDropDownContent($container, target) {
		$container.addClass('visible');
		$container.find('.js-dropdown').addClass('hidden');
		$container.find('.' + target).removeClass('hidden');
		if (target === 'js-labourcost-form') {
			$('.js-mdo-input').trigger('focus');
			var $responseElem = $('.js-mdo-respuesta');
			$responseElem.removeClass('visible');
		}
	};

	var _initVMButton = function _initVMButton() {
		$('.js-vm-button').off('click').on('click', function (ev) {
			// Aquí se hará un envío AJAX para que se cambie el valor de la variable de sesión
			// La respuesta será el nuevo valor de la variable, por tanto la siguiente llamada se hará tras la respuesta AJAX
			var profile = parseInt(profilesControl.getCurProfile());
			var display = parseInt($(this).data('viewmode'));
			var mdo = parseFloat(profilesControl.getCurMdo());
			var codhost = profilesControl.getCurCodhost();
			var concesion = profilesControl.getCurConcesion();

			$.ajax({
				url: location.pathname + '?pMode=profilesControl&pDisplay=' + display,
				dataType: 'script',
				success: function success() {
					var jsonMdo = profilesControl.getCurMdo();
					profilesControl.set(profile, display, jsonMdo, codhost, concesion);
				}
			});
		});
	};

	var _initMobileOpener = function _initMobileOpener() {
		initiatedMobileOpener = true;
		$opener = $('.js-pd-opener');
		$opener.on('click', function () {
			if (!$opener.hasClass('abierto')) {
				_openPdMobile($opener);
			} else {
				_closePdMobile($opener);
			}
		});
		$(window).on('resize', function () {
			_checkScreen();
		});
	};

	var _openPdMobile = function _openPdMobile($opener) {
		$opener.addClass('abierto');
		$('.js-pd-links').removeClass('mobileClosed');
		$('.js-first-mobile-button').trigger('click');
	};

	var _closePdMobile = function _closePdMobile($opener) {
		$opener.removeClass('abierto');
		$('.js-pd-links').addClass('mobileClosed');
		$('.js-dropdown-container').removeClass('visible');
		$('.js-dropdown-button').removeClass('abierto');
	};

	var _checkScreen = function _checkScreen() {
		if ($(window).width() > 767) {
			scrLessThan767 = false;
			if ($opener.hasClass('abierto')) _closePdMobile($opener);
		} else {
			scrLessThan767 = true;
		}
	};

	var _launch = function _launch() {
		if (!initiatedDropDown) {
			_initDropDown();
		}
		_initVMButton();
		if (!initiatedMobileOpener) {
			_initMobileOpener();
		}

		_checkScreen();
	};

	return {
		launch: _launch
	};
}();

var _validate = function _validate(value) {
	var format = /^\d{1,3}(\.\d{1,2})?$/.test(value);
	if (format && parseInt(value) <= 500) {
		return true;
	} else {
		return false;
	}
};

var mdoControl = function () {
	var _init = function _init(jsonMdo, status) {
		var mdo = parseFloat(jsonMdo.precio);
		var modified = !!jsonMdo.modificado;
		console.log('mdo en init', mdo, 'status en mdoinit', status, 'mdo modificado', modified);

		if (status === 4 && !modified) {
			console.log('Aviso Mdo Sin Elección');
			_showAlertMdo(mdo, false);
		}
		if (status === 3) {
			if (modified) {
				_ctrlChangeMdo(mdo, '#js-mdo-form', false);
			} else {
				console.log('Aviso Mdo Completo');
				_showAlertMdo(mdo, true);
			}
		}
	};

	var _ctrlChangeMdo = function _ctrlChangeMdo(mdo, formSelector, isCbox) {
		console.log('Rellenando el form con el valor', mdo);
		if (isCbox) {
			$('.js-mdo-price').text(mdo);
		}
		$(formSelector).find('.js-mdo-input').val(mdo).on('focus input', function () {
			$('.js-mdo-form-error').removeAttr('style');
			$('.js-msg-error').addClass('hidden');
		});
		$(formSelector).on('submit', function (ev) {
			$('.js-mdo-form-error').removeAttr('style');
			$('.js-msg-error').addClass('hidden');
			var outMdo = $(formSelector).find('.js-mdo-input').val().replace(',', '.');

			var valid = _validate(outMdo);
			ev.preventDefault();

			if (valid) {
				if (sessionStorage.mdoPrice != outMdo || isCbox) {
					_sendMdo(outMdo, isCbox);
				}
			} else {
				_errorMdo(1);
			}
		});
	};

	var _sendMdo = function _sendMdo(outMdo, isCbox) {
		console.log('enviando Mdo');
		if (isCbox) $.colorbox.close();

		var curCodhost = profilesControl.getCurCodhost();
		var $responseElem = $('.js-mdo-respuesta');
		$.ajax({
			url: location.pathname + '?pMode=setManoObraConces&pvCode=' + curCodhost + '&pnPrecio=' + outMdo,
			success: function success(response) {
				if (response === 'OK') {
					$responseElem.removeClass('visible');
					var delayed = function delayed() {
						$responseElem.addClass('visible');
						$('.js-mdo-input').val(outMdo);
						sessionStorage.mdoPrice = outMdo;
						profilesControl.setCurMdo(outMdo);
						if (accesoryPage) {
							console.log('Recargar Ficha Accesorio');
							accesory.reload();
						}
						if (cartListPage) {
							console.log('Recalcular Precios Accesorios');
							cartList.makeList();
						}
					};
					window.setTimeout(delayed, 1);
				} else {
					_errorMdo(2);
				}
			}
		});
	};

	var _errorMdo = function _errorMdo(type) {
		$('.js-mdo-form-error').show();
		$('.js-msg-error').addClass('hidden');
		var $msg = void 0;
		switch (type) {
			case 1:
				$msg = $('.js-format');
				break;
			case 2:
				$msg = $('.js-generic');
				break;
			default:
				$msg = $('.js-generic');
				break;
		}
		$msg.removeClass('hidden');
	};

	var _showAlertMdo = function _showAlertMdo(mdo, withChangeForm) {
		if (withChangeForm) {
			var alertCbx = $.colorbox({
				href: '.js-alert-mdo-1',
				inline: true,
				width: '90%',
				maxWidth: '560px',
				height: 'auto',
				overlayClose: false,
				className: 'mdo',
				opacity: '0.6',
				onComplete: function onComplete() {
					_ctrlChangeMdo(mdo, '#js-change-mdo-form', true);
					_ctrlChangeMdo(mdo, '#js-mdo-form', false);
				}
			});
		} else {
			if (!sessionStorage.alertMdo2) {
				var _alertCbx = $.colorbox({
					href: '.js-alert-mdo-2',
					inline: true,
					width: '90%',
					maxWidth: '540px',
					height: 'auto',
					overlayClose: false,
					className: 'mdo-2',
					opacity: '0.6',
					onComplete: function onComplete() {
						sessionStorage.alertMdo2 = true;
						$('.js-mdo-price').text(mdo);
						$('.js-aceptar').on('click', function () {
							return $.colorbox.close();
						});
					}
				});
			}
		}
	};

	return {
		init: _init
	};
}();